import React from 'react';
import { Label, Row, Col } from 'reactstrap';
import Name from '../common/Name';
import ProfileAvatar from '../common/ProfileAvatar';
import ReactQuill from 'react-quill';

class Add extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props.person
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps && (prevState.modifiedDate !== nextProps.person.modifiedDate))
            return { ...nextProps.person };

        return null;
    }

    handleNameChange = (name) => this.setState({ ...name }, () => this.props.onChange(this.state));

    handleOnAddressChange = (addresses) => this.setState({ addresses }, () => this.props.onChange(this.state));

    handleOnPhoneChange = (phones) => this.setState({ phones }, () => this.props.onChange(this.state));

    handleOnPersonTypeChange = (e) => this.setState({ personType: e.target.value }, () => this.props.onChange(this.state));

    handleOnImageChange = (image) => this.setState({ image, imageUrl: null }, () => this.props.onChange(this.state));

    handleOnBioChange = (bio) => {
        if (this.state.bio !== bio)
            this.setState({ bio }, () => this.props.onChange(this.state));
    }

    render() {
        return (
            <React.Fragment>
                <Row className='mb-3'>
                    {!this.props.person.isProgramPOC &&
                        <Col xl='2'>
                            <ProfileAvatar
                                onChange={this.handleOnImageChange}
                                image={this.state.imageUrl || (this.state.image ? `data:image/png;base64, ${this.state.image}` : null)}
                            />
                        </Col>
                    }
                    <Col xl={this.props.person.isProgramPOC ? '12' : '10'} >
                        <Name
                            {...this.props.person}
                            fromContactDemographics={true}
                            toggleContactNameValidState={this.props.toggleContactNameValidState}
                            properTitles={this.props.properTitles}
                            generations={this.props.generations}
                            onChange={this.handleNameChange}
                        />
                    </Col>
                </Row>
                <Row>
                    {!this.props.person.isProgramPOC &&
                        <Col>
                            <Label>Bio:</Label>
                            <ReactQuill
                                value={this.state.bio || ''}
                                onChange={this.handleOnBioChange}
                            />
                        </Col>
                    }
                </Row>
            </React.Fragment>
        )
    }
}

export default Add